import { render } from "./MyReservations.vue?vue&type=template&id=5dadf34f&scoped=true"
import script from "./MyReservations.vue?vue&type=script&lang=js"
export * from "./MyReservations.vue?vue&type=script&lang=js"

import "./MyReservations.vue?vue&type=style&index=0&id=5dadf34f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dadf34f"]])

export default __exports__